<template>
  <nav id="nav" class="sm:container sm:mx-auto">
    <!-- Header start -->
    <div class="z-10 max-w-screen-lg xl:max-w-screen-xl block sm:flex sm:justify-between sm:items-center my-6">
      <!-- Header menu links and small screen hamburger menu -->
      <div class="flex justify-between items-center px-4 sm:px-0">
        <!-- Header logos -->
        <div>
          <router-link to="/"><img v-if="theme === 'light'" src="@/assets/images/logo_v2.png" class="w-36 dark-logo"
              alt="Dark Logo" />
            <img v-else src="@/assets/images/logo.png" class="w-36" alt="Light Logo" />
          </router-link>
        </div>

        <!-- Theme switcher small screen -->
        <theme-switcher :theme="theme" @themeChanged="updateTheme"
          class="block sm:hidden bg-ternary-light dark:bg-ternary-dark hover:bg-hover-light dark:hover:bg-hover-dark hover:shadow-sm px-2.5 py-2 rounded-lg" />

        <!-- Small screen hamburger menu -->
        <div class="sm:hidden">
          <button @click="isOpen = !isOpen" type="button" class="focus:outline-none" aria-label="Hamburger Menu">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              class="h-7 w-7 fill-current text-secondary-dark dark:text-ternary-light">
              <path v-if="isOpen" fill-rule="evenodd"
                d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                clip-rule="evenodd"></path>
              <path v-if="!isOpen" fill-rule="evenodd"
                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z">
              </path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Header links -->
      <AppHeaderLink :showModal="showModal" :isOpen="isOpen" />

      <!-- Header right section buttons -->
      <div class="hidden sm:flex justify-between items-center flex-col md:flex-row">
        <!-- Hire me button -->
        <div class="hidden md:block">
          <Button :title="$t('titleResume')"
            class="text-md font-general-medium bg-cyan-500 hover:bg-cyan-600 text-white shadow-sm rounded-md px-5 py-2.5 duration-300"
            @click="openResume()" aria-label="Resume Link" target="_blank"></Button>
        </div>
        

        <!-- Theme switcher large screen -->
        <theme-switcher :theme="theme" @themeChanged="updateTheme"
          class="m-8 bg-primary-light dark:bg-ternary-dark px-3 py-2 shadow-sm rounded-xl cursor-pointer" />
          <!-- i18n language switcher -->
          <div class="hidden sm:flex items-center dark:text-ternary-light text-primary-dark">
            <button @click="$i18n.locale = 'en'" :class="{ 'font-bold': $i18n.locale === 'en' }">{{ $t('langEn') }}</button>
            <span class="mx-2">/</span>
            <button @click="$i18n.locale = 'ja'" :class="{ 'font-bold': $i18n.locale === 'ja' }">{{ $t('langJp') }}</button>
          </div>
      </div>
    </div>

    <!-- Hire me modal -->
    <!-- <HireMeModal :showModal="showModal" :modal="modal" :categories="categories" aria-modal="Hire Me Modal" /> -->
  </nav>
</template>

<script>
import Button from '../reusable/Button.vue';
import ThemeSwitcher from '../ThemeSwitcher.vue';
import feather from 'feather-icons';
import AppHeaderLink from './AppHeaderLinks.vue';
// import HireMeModal from '../HireMeModal.vue';

export default {
  data() {
    return {
      isOpen: false,
      theme: '',
      modal: false,
      categories: [
        {
          id: 1,
          value: 'web',
          name: 'Web Site / Application',
        },
        {
          id: 2,
          value: 'mobile',
          name: 'Mobile Application',
        },
        {
          id: 3,
          value: 'ui-ux',
          name: 'UI/UX Design',
        },
        {
          id: 4,
          value: 'other',
          name: 'Other',
        },
      ],
      showModal: false,
    }
  },
  components: {
    Button,
    ThemeSwitcher,
    AppHeaderLink,
    // HireMeModal,
  },
  created() {
    this.theme = localStorage.getItem('theme') || 'light';
  },
  mounted() {
    feather.replace();
    this.theme = localStorage.getItem('theme') || 'light';
  },
  methods: {
    updateTheme(theme) {
      this.theme = theme;
    },
    openResume() {
      // open new page in the new tab
      const resumeUrl = this.$i18n.locale === 'ja' 
        ? 'https://acrobat.adobe.com/id/urn:aaid:sc:AP:93240020-08a7-485f-96e4-e3a9f2d9416f' 
        : 'https://acrobat.adobe.com/id/urn:aaid:sc:AP:3cdcf7d5-436e-4669-bdda-d4835ce287a3';
      window.open(resumeUrl, '_blank');
    }
  },
  update() {
    feather.replace();
  },
}
</script>

<!-- <style scoped>
.dark-logo {
  filter: brightness(0.5);
}
</style> -->